import { OpenAPI as CollCalcOpenAPI } from '@festina/collcalc-general-types/collcalc'
import { ConfigurationChangesetsService as CollCalcConfigurationChangesetsService } from '@festina/collcalc-general-types/collcalc/services/ConfigurationChangesetsService'
import { ConfigurationMetaService as CollCalcConfigurationMetaService } from '@festina/collcalc-general-types/collcalc/services/ConfigurationMetaService'
import { ConfigurationTenantsService as CollCalcConfigurationTenantsService } from '@festina/collcalc-general-types/collcalc/services/ConfigurationTenantsService'
import { OpenAPI as CollCalcTestOpenAPI } from '@festina/collcalc-general-types/collcalc-test'
import { OpenAPI as ConfigurationOpenAPI } from '@festina/configuration-general-types/configuration'
import { ConfigurationMetaService as ConfigurationConfigurationMetaService } from '@festina/configuration-general-types/configuration/services/ConfigurationMetaService'
import { ConfigurationRepositoryBranchesService as ConfigurationConfigurationRepositoryBranchesService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryBranchesService'
import { ConfigurationRepositoryWorkspacesService as ConfigurationConfigurationRepositoryWorkspacesService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryWorkspacesService'
import { OpenAPI as ConfigurationTestOpenAPI } from '@festina/configuration-general-types/configuration-test'
import { OpenAPI as LegalEntityOpenAPI } from '@festina/legalentity-general-types/legalentity'
import { ConfigurationChangesetsService as legalentityConfigurationChangesetsService } from '@festina/legalentity-general-types/legalentity/services/ConfigurationChangesetsService'
import { ConfigurationMetaService as legalentityConfigurationMetaService } from '@festina/legalentity-general-types/legalentity/services/ConfigurationMetaService'
import { ConfigurationTenantsService as legalentityConfigurationTenantsService } from '@festina/legalentity-general-types/legalentity/services/ConfigurationTenantsService'
import { OpenAPI as LegalEntityTestOpenAPI } from '@festina/legalentity-general-types/legalentity-test'
import { OpenAPI as LifeOpenAPI } from '@festina/life-general-types/life'
import { ConfigurationChangesetsService as LifeConfigurationChangesetsService } from '@festina/life-general-types/life/services/ConfigurationChangesetsService'
import { ConfigurationMetaService as LifeConfigurationMetaService } from '@festina/life-general-types/life/services/ConfigurationMetaService'
import { ConfigurationTenantsService as LifeConfigurationTenantsService } from '@festina/life-general-types/life/services/ConfigurationTenantsService'
import { OpenAPI as LifeTestOpenAPI } from '@festina/life-general-types/life-test'
import { OpenAPI as MoneyInOpenAPI } from '@festina/moneyin-general-types/moneyin'
import { ConfigurationChangesetsService as MoneyInConfigurationChangesetsService } from '@festina/moneyin-general-types/moneyin/services/ConfigurationChangesetsService'
import { ConfigurationMetaService as MoneyInConfigurationMetaService } from '@festina/moneyin-general-types/moneyin/services/ConfigurationMetaService'
import { ConfigurationTenantsService as MoneyInConfigurationTenantsService } from '@festina/moneyin-general-types/moneyin/services/ConfigurationTenantsService'
import { OpenAPI as MoneyInTestOpenAPI } from '@festina/moneyin-general-types/moneyin-test'
import { OpenAPI as MoneyOutOpenAPI } from '@festina/moneyout-general-types/moneyout'
import { ConfigurationChangesetsService as MoneyOutConfigurationChangesetsService } from '@festina/moneyout-general-types/moneyout/services/ConfigurationChangesetsService'
import { ConfigurationMetaService as MoneyOutConfigurationMetaService } from '@festina/moneyout-general-types/moneyout/services/ConfigurationMetaService'
import { ConfigurationTenantsService as MoneyOutConfigurationTenantsService } from '@festina/moneyout-general-types/moneyout/services/ConfigurationTenantsService'
import { OpenAPI as MoneyOutTestOpenAPI } from '@festina/moneyout-general-types/moneyout-test'
import { OpenAPI as UnitLinkOpenAPI } from '@festina/unitlink-general-types/unitlink'
import { ConfigurationChangesetsService as UnitLinkConfigurationChangesetsService } from '@festina/unitlink-general-types/unitlink/services/ConfigurationChangesetsService'
import { ConfigurationMetaService as UnitLinkConfigurationMetaService } from '@festina/unitlink-general-types/unitlink/services/ConfigurationMetaService'
import { ConfigurationTenantsService as UnitLinkConfigurationTenantsService } from '@festina/unitlink-general-types/unitlink/services/ConfigurationTenantsService'
import { OpenAPI as UnitLinkTestOpenAPI } from '@festina/unitlink-general-types/unitlink-test'

export const ConfigurationService = {
  ConfigurationMetaService: ConfigurationConfigurationMetaService,
  ConfigurationRepositoryBranchesService:
    ConfigurationConfigurationRepositoryBranchesService,
  ConfigurationRepositoryWorkspacesService:
    ConfigurationConfigurationRepositoryWorkspacesService,
  ConfigurationTenantsService: {
    // Tenant fetching is done on the configuration component through the fetching and parsing of changesets.
    tenantsServiceGetGetRegisteredTenants: Promise.resolve,
  },
  OpenAPI: ConfigurationOpenAPI,
}

type Service = Record<
  | 'ConfigurationMetaService'
  | 'ConfigurationTenantsService'
  | 'OpenAPI'
  | 'ConfigurationChangesetsService',
  unknown
>

export const CollCalcService = {
  ConfigurationMetaService: CollCalcConfigurationMetaService,
  ConfigurationTenantsService: CollCalcConfigurationTenantsService,
  OpenAPI: CollCalcOpenAPI,
  ConfigurationChangesetsService: CollCalcConfigurationChangesetsService,
} satisfies Service

export const LegalEntityService = {
  ConfigurationMetaService: legalentityConfigurationMetaService,
  ConfigurationTenantsService: legalentityConfigurationTenantsService,
  OpenAPI: LegalEntityOpenAPI,
  ConfigurationChangesetsService: legalentityConfigurationChangesetsService,
} satisfies Service

export const LifeService = {
  ConfigurationMetaService: LifeConfigurationMetaService,
  ConfigurationTenantsService: LifeConfigurationTenantsService,
  OpenAPI: LifeOpenAPI,
  ConfigurationChangesetsService: LifeConfigurationChangesetsService,
} satisfies Service

export const MoneyInService = {
  ConfigurationMetaService: MoneyInConfigurationMetaService,
  ConfigurationTenantsService: MoneyInConfigurationTenantsService,
  OpenAPI: MoneyInOpenAPI,
  ConfigurationChangesetsService: MoneyInConfigurationChangesetsService,
} satisfies Service

export const MoneyOutService = {
  ConfigurationMetaService: MoneyOutConfigurationMetaService,
  ConfigurationTenantsService: MoneyOutConfigurationTenantsService,
  OpenAPI: MoneyOutOpenAPI,
  ConfigurationChangesetsService: MoneyOutConfigurationChangesetsService,
} satisfies Service

export const UnitLinkService = {
  ConfigurationMetaService: UnitLinkConfigurationMetaService,
  ConfigurationTenantsService: UnitLinkConfigurationTenantsService,
  OpenAPI: UnitLinkOpenAPI,
  ConfigurationChangesetsService: UnitLinkConfigurationChangesetsService,
} satisfies Service

type TestService = Record<'OpenAPI', unknown>

export const CollCalcTestService = {
  OpenAPI: CollCalcTestOpenAPI,
} satisfies TestService

export const LegalEntityTestService = {
  OpenAPI: LegalEntityTestOpenAPI,
} satisfies TestService

export const LifeTestService = {
  OpenAPI: LifeTestOpenAPI,
} satisfies TestService

export const MoneyInTestService = {
  OpenAPI: MoneyInTestOpenAPI,
} satisfies TestService

export const MoneyOutTestService = {
  OpenAPI: MoneyOutTestOpenAPI,
} satisfies TestService

export const UnitLinkTestService = {
  OpenAPI: UnitLinkTestOpenAPI,
} satisfies TestService

export const ConfigurationTestService = {
  OpenAPI: ConfigurationTestOpenAPI,
} satisfies TestService
